import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {AddSettlementsTemplateComponent} from "../add-settlements-template/add-settlements-template.component";
import {SettlementTemplate} from "../../../../shared/interface/settlement-template";

export interface SettlementTemplateAddDialogData {
  settlementTemplateObject?: SettlementTemplate;
}
@Component({
  selector: 'app-add-settlements-template-dialog',
  templateUrl: './add-settlements-template-dialog.component.html',
  styleUrls: ['./add-settlements-template-dialog.component.scss']
})
export class AddSettlementsTemplateDialogComponent implements OnInit {
  settlementTemplateObject?: SettlementTemplate = null;
  constructor(
    public dialogRef: MatDialogRef<AddSettlementsTemplateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SettlementTemplateAddDialogData,
  ) {
    this.settlementTemplateObject = data?.settlementTemplateObject;
  }

  ngOnInit(): void {
  }
  closeDialog(e): void {
    this.dialogRef.close(e);
  }
}
